module.exports = __webpack_public_path__ + "img/kormanyvaltasig_nem_szulok_12.0d387054.jpg";